/* Manual mobile controls complement native swipe. No autoplay or desktop override. */
(() => {
  const selector = 'main .swipe-mobile, main .section-trust-badges [class$="__list"], main .comparatif-serres__cards';
  const mobile = matchMedia('(max-width: 767.98px)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const tracks = new Map();
  let sequence = 0;
  function setup(track) {
    if (tracks.has(track)) return;
    const inner = track.querySelector('.swipe-mobile__inner') || track;
    if (inner.children.length < 2) return;
    const controls = document.createElement('div');
    controls.className = 'lsdj-v8-carousel-controls';
    controls.hidden = true;
    track.id ||= `lsdj-v8-carousel-${++sequence}`;
    const heading = track.closest('.shopify-section')?.querySelector('h2')?.textContent.trim();
    const context = heading || (track.matches('[class$="__list"]') ? 'Nos avantages' : 'Le carrousel');
    const makeButton = (label, path) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', `${label} : ${context}`);
      button.setAttribute('aria-controls', track.id);
      button.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${path}"/></svg>`;
      return button;
    };
    const prev = makeButton('Élément précédent', 'm14 5-7 7 7 7M7 12h14');
    const next = makeButton('Élément suivant', 'm10 5 7 7-7 7M3 12h14');
    const count = document.createElement('span');
    controls.append(prev, count, next);
    track.after(controls);
    const positions = () => {
      const rect = track.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      return [...inner.children].map(el => Math.min(max, Math.max(0, el.getBoundingClientRect().left - rect.left + track.scrollLeft - padding)));
    };
    function update() {
      const enabled = mobile.matches && track.clientWidth > 0 && track.scrollWidth > track.clientWidth + 2;
      controls.hidden = !enabled;
      if (!enabled) return;
      const stops = positions();
      let index = 0;
      stops.forEach((left, i) => { if (Math.abs(left - track.scrollLeft) < Math.abs(stops[index] - track.scrollLeft)) index = i; });
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      count.textContent = `${index + 1} / ${stops.length}`;
    }
    function move(direction) {
      const stops = positions();
      const left = direction > 0 ? stops.find(value => value > track.scrollLeft + 3) : [...stops].reverse().find(value => value < track.scrollLeft - 3);
      if (left !== undefined) track.scrollTo({ left, behavior: reduced.matches ? 'instant' : 'smooth' });
    }
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, { passive: true });
    const resize = new ResizeObserver(update);
    resize.observe(track);
    tracks.set(track, { update, resize, controls });
    update();
  }
  function enhance() {
    document.querySelectorAll(selector).forEach(setup);
    tracks.forEach((entry, track) => {
      if (!track.isConnected) { entry.resize.disconnect(); entry.controls.remove(); tracks.delete(track); }
    });
  }
  mobile.addEventListener('change', () => tracks.forEach(entry => entry.update()));
  document.addEventListener('shopify:section:load', enhance);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(enhance));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once: true });
  else enhance();
})();
